// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.collapsible-container {
  text-align: center;
  margin: 20px auto;
  width: 100%;
}
/* Clickable Header */
.collapsible-header {
  background-color: #007bff;
  color: white;
  padding: 12px;
  font-size: 18px;
  font-weight: bold;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background 0.3s ease;
}
.collapsible-header:hover {
  background-color: #0056b3;
}
/* Arrow Indicator */
.arrow {
  transition: transform 0.3s ease-in-out;
}
.arrow.open {
  transform: rotate(180deg);
}
/* Collapsible Content */
.collapsible-content {
  background-color: #f9f9f9;
  border: 2px solid #ddd;
  border-radius: 10px;
  padding: 0 20px;
  text-align: left;
  color: #333;
  line-height: 1.8;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.5s ease-in-out, padding 0.3s ease-in-out;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
/* Show when expanded */
.collapsible-content.show {
  max-height: 500px;
  /* Adjust based on content size */
  padding: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/utils/CollapsibleSection.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,iBAAA;EACA,WAAA;AACF;AACA,qBAAqB;AAErB;EACE,yBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gCAAA;AAAF;AAGA;EACE,yBAAA;AADF;AACA,oBAAoB;AAIpB;EACE,sCAAA;AAFF;AAKA;EACE,yBAAA;AAHF;AACA,wBAAwB;AAMxB;EACE,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,iEAAA;EACA,cAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;AALF;AACA,uBAAuB;AAQvB;EACE,iBAAA;EANA,iCAAiC;EAQjC,aAAA;AANF","sourcesContent":[".collapsible-container {\n  text-align: center;\n  margin: 20px auto;\n  width: 100%;\n}\n\n/* Clickable Header */\n.collapsible-header {\n  background-color: #007bff;\n  color: white;\n  padding: 12px;\n  font-size: 18px;\n  font-weight: bold;\n  border-radius: 8px;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: background 0.3s ease;\n}\n\n.collapsible-header:hover {\n  background-color: #0056b3;\n}\n\n/* Arrow Indicator */\n.arrow {\n  transition: transform 0.3s ease-in-out;\n}\n\n.arrow.open {\n  transform: rotate(180deg);\n}\n\n/* Collapsible Content */\n.collapsible-content {\n  background-color: #f9f9f9;\n  border: 2px solid #ddd;\n  border-radius: 10px;\n  padding: 0 20px;\n  text-align: left;\n  color: #333;\n  line-height: 1.8;\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.5s ease-in-out, padding 0.3s ease-in-out;\n  overflow: auto;\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n/* Show when expanded */\n.collapsible-content.show {\n  max-height: 500px;\n  /* Adjust based on content size */\n  padding: 20px;\n}\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
